(function () {
  const root = document.getElementById("hero-slider");
  if (!root) return;

  const slides = Array.from(root.querySelectorAll("[data-slide-index]"));
  const dots = Array.from(root.querySelectorAll("[data-hero-dot]"));
  const prevBtn = root.querySelector("[data-hero-prev]");
  const nextBtn = root.querySelector("[data-hero-next]");

  if (slides.length <= 1) return;

  const autoplay = root.dataset.autoplay === "true";
  const speed = Number(root.dataset.speed) || 5000;
  let current = 0;
  let timer = null;

  function update(next) {
    slides[current].classList.remove("is-active");
    dots[current]?.classList.remove("is-active");
    dots[current]?.setAttribute("aria-selected", "false");

    current = (next + slides.length) % slides.length;

    slides[current].classList.add("is-active");
    dots[current]?.classList.add("is-active");
    dots[current]?.setAttribute("aria-selected", "true");
  }

  function next() {
    update(current + 1);
  }

  function prev() {
    update(current - 1);
  }

  function stopAuto() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  function startAuto() {
    if (!autoplay) return;
    stopAuto();
    timer = setInterval(next, speed);
  }

  nextBtn?.addEventListener("click", () => {
    next();
    startAuto();
  });

  prevBtn?.addEventListener("click", () => {
    prev();
    startAuto();
  });

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      const idx = Number(dot.dataset.heroDot);
      if (Number.isNaN(idx)) return;
      update(idx);
      startAuto();
    });
  });

  root.addEventListener("mouseenter", stopAuto);
  root.addEventListener("mouseleave", startAuto);

  // Touch / swipe support
  let touchStartX = 0;
  let touchEndX = 0;
  const SWIPE_THRESHOLD = 50;

  root.addEventListener("touchstart", (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  root.addEventListener("touchend", (e) => {
    touchEndX = e.changedTouches[0].screenX;
    const diff = touchStartX - touchEndX;
    if (Math.abs(diff) > SWIPE_THRESHOLD) {
      if (diff > 0) {
        next();
      } else {
        prev();
      }
      startAuto();
    }
  }, { passive: true });

  startAuto();
})();
